import { Button, Form, Icon, Input } from 'antd'
import { Dispatch } from 'easy-peasy'
import React from 'react'
import { connect } from 'react-redux'
import { Redirect, RouteChildrenProps, withRouter } from 'react-router'
import styled from 'styled-components'
import { AppRoutes, getRoute } from '../AppRoutes'
import { graphTranslations } from '../Diagrams/graphTranslations'
import { SignupRequest } from '../DTO/BaseApiDTO'
import RedoxLogo from '../RedoxLogo'
import { IApplicationModel, IApplicationState } from '../store/store'
import polyglot from '../Translator'
import { LoginLink } from './Login'

const SignupContainer = styled.div`
  margin-top: 10vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

interface IProps extends IStateProps, IDispatchProps, RouteChildrenProps<any, { from?: string }> {
  form: any
}

const Signup = (props: IProps) => {
  let redirectTo = AppRoutes.MY_DIAGRAMS as string

  if (props.location && props.location.state && props.location.state.from) {
    redirectTo = props.location.state.from
  }

  async function onSignupClick(e) {
    try {
      const values = await getValidatedValues(e)
      await props.signUp(values)
      props.history.push(getRoute(redirectTo))
    } catch (error) {
      console.error(error)
    }
  }

  const goToLogin = () => props.history.push(getRoute(AppRoutes.LOGIN), props.location.state)

  const getValidatedValues = (e): Promise<SignupRequest> => {
    e.preventDefault()
    return new Promise((resolve, reject) => {
      props.form.validateFields((err, values) => {
        if (!err) {
          resolve(values)
        } else {
          reject(err)
        }
      })
    })
  }

  const { getFieldDecorator } = props.form

  return !props.isLoggedIn ? (
    <SignupContainer>
      <RedoxLogo width={400} />
      <Form onSubmit={getValidatedValues} style={{ width: '300px', marginTop: '50px', textAlign: 'center' }}>
        <h2>{polyglot.tr(graphTranslations.createNewAccount)}</h2>
        <Form.Item>
          {getFieldDecorator('email', {
            rules: [
              {
                required: true,
                message: polyglot.t('provideEmail')
              }
            ]
          })(
            <Input
              prefix={<Icon type="mail" style={{ color: 'rgba(0,0,0,.25)' }} />}
              placeholder={polyglot.t('email')}
            />
          )}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator('name', {
            rules: [
              {
                required: true,
                message: polyglot.t('provideName')
              }
            ]
          })(
            <Input
              prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
              placeholder={polyglot.t('name')}
            />
          )}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator('password', {
            rules: [
              {
                required: true,
                message: 'Veuillez entrer votre mot de passe.'
              }
            ]
          })(
            <Input
              prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
              type="password"
              placeholder={polyglot.t('password')}
            />
          )}
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" style={{ width: '100%' }} onClick={onSignupClick}>
            {polyglot.t('register')}
          </Button>
          <br />
          <div
            style={{
              textAlign: 'center'
            }}
          >
            <LoginLink onClick={goToLogin}> {polyglot.t('alreadyHasAccount')}</LoginLink>
          </div>
        </Form.Item>
      </Form>
    </SignupContainer>
  ) : (
    <Redirect to={getRoute(redirectTo)} />
  )
}

interface IStateProps {
  isLoggedIn: boolean
}
interface IDispatchProps {
  signUp: (user) => void
}

const mapStateToProps = (state: IApplicationState): IStateProps => ({
  isLoggedIn: !!state.user.user
})

const mapDispatchToProps = (dispatch: Dispatch<IApplicationModel>): IDispatchProps => ({
  signUp: user => dispatch.user.signUp(user)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Form.create({ name: 'signup' })(withRouter(Signup)))
